import { useEffect, useState } from 'react';

const supported = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function';

/** Whether the media query matches now and as the window changes. */
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() =>
        supported() ? window.matchMedia(query).matches : false
    );

    useEffect(() => {
        if (!supported()) return undefined;
        const list = window.matchMedia(query);
        const onChange = () => setMatches(list.matches);
        onChange();
        list.addEventListener('change', onChange);
        return () => list.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}

export default useMediaQuery;
